import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { RDDarkService } from './../../dark.service';

@Component({
  selector: 'rd-check-box-option',
  template: `<span class="checkBoxContainer {{color}}CheckBox {{display}}" [class.rdDark]="dark" (click)="changeCheck()">
  <span class="checkMark" [class.checked]="checked"></span>
  <ng-content></ng-content>
</span>
`,
  styles: [`.checkBoxContainer{--main-color:#ba9e5a;--text-color:black;--background-color:#f1f1f1;cursor:pointer;padding:3px;position:relative;transition:all .3s ease-in-out;color:var(--text-color);transition:all .3s linear}.checkBoxContainer:active{background-color:var(--background-color)}.checkBoxContainer:hover{color:var(--main-color)}.checkBoxContainer.line{display:block}.checkBoxContainer .checkMark{position:relative;width:20px;height:20px;background-color:#e3e3e3;display:inline-block;vertical-align:middle;margin:3px 6px 3px 0;transition:all .3s ease-in-out}.checkBoxContainer .checkMark:after{content:'';position:absolute}.checkBoxContainer .checkMark.checked{background-color:var(--main-color)}.checkBoxContainer .checkMark.checked:after{width:6px;height:12px;border:solid #fff;border-width:0 3px 3px 0;top:2px;left:6px;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.checkBoxContainer.blueCheckBox{--main-color:#5a5aba}.checkBoxContainer.greenCheckBox{--main-color:#72ba5a}.checkBoxContainer.blue-lightCheckBox{--main-color:#5aa2ba}.checkBoxContainer.redCheckBox{--main-color:#ba5a5a}.checkBoxContainer.purpleCheckBox{--main-color:#a25aba}.checkBoxContainer.orangeCheckBox{--main-color:#ba8a5a}.checkBoxContainer.rdDark{--text-color:white;--background-color:#07384c}`]
})
export class RDCheckBoxOptionComponent implements OnInit {

  @Input() value = '';

  @Output() checkedChange: EventEmitter<any> = new EventEmitter();

  public checked = false;
  public color = 'gold';
  public display = 'line';
  public dark = false;

  constructor(private darkService: RDDarkService) { }

  ngOnInit() {
    this.darkService.getDarkElement().subscribe(() => {
      this.dark = this.darkService.isDark();
    });
    this.dark = this.darkService.isDark();
  }

  changeCheck() {
    this.checked = !this.checked;
    this.checkedChange.emit(this.checked);
  }

}
